import { useTranslation } from 'react-i18next';

import { Button } from '@cfa/react-components';

interface EditButtonsProps {
  onCancel: () => void;
  onEdit: () => void;
  primaryButtonText?: string;
  validated?: boolean;
}

const EditButtons: React.FC<EditButtonsProps> = ({
  onCancel,
  onEdit,
  validated,
  primaryButtonText,
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex w-full flex-row items-center gap-4">
      <Button
        color="secondary"
        onClick={onCancel}
        variant="outlined"
        className="min-w-0!"
      >
        {t('Button.cancel')}
      </Button>
      <Button
        color="secondary"
        data-testid="EditButtonPrimary"
        disabled={!validated}
        onClick={onEdit}
        variant="filled"
        className="min-w-0!"
      >
        {primaryButtonText ?? t('Button.update')}
      </Button>
    </div>
  );
};

export default EditButtons;
